<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-select-pickup-delivery"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectPickupDelivery"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-select-pickup-delivery"
      data-bs-target="#modalSelectPickupDelivery"
      data-bs-dismiss="modal"
    ></button>
    <div
      class="modal fade"
      id="modalSelectPickupDelivery"
      tabindex="-1"
      aria-labelledby="modalSelectPickupDeliveryTitle"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div id="modalSelectPickupDeliveryTitle" class="choice-title text-center">
              {{ $t('cart.choosePickupOrDelivery') }}
            </div>
            <div class="d-flex gap-3 mt-3">
              <button type="button" class="choice-card" @click="choose(1)">
                <span class="material-icons-round choice-icon">storefront</span>
                <span class="choice-name">{{ $t('cart.pickUp') }}</span>
                <span class="choice-text">{{ $t('cart.pickupCardText') }}</span>
              </button>
              <button type="button" class="choice-card" @click="choose(2)">
                <span class="material-icons-round choice-icon">delivery_dining</span>
                <span class="choice-name">{{ $t('cart.delivery') }}</span>
                <span class="choice-text">{{ $t('cart.deliveryCardText') }}</span>
              </button>
            </div>
            <div class="text-center mt-3">
              <button type="button" class="browse-link" @click="choose(0)">
                {{ $t('cart.justBrowsing') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// M986 follow-up: MOO asks Pickup or Delivery when the customer opens the menu.
// 1 = Pickup, 2 = Delivery (same values as MyCart's btnSelected), 0 = just browsing.
export default {
  name: "ModalSelectPickupDelivery",
  emits: ["select"],
  methods: {
    choose(value) {
      document.querySelector(".btn-hide-modal-select-pickup-delivery")?.click();
      this.$emit("select", value);
    },
  },
};
</script>

<style scoped>
.modal {
  overflow-y: hidden !important;
}
.choice-title {
  font-size: 18px;
  font-weight: 600;
}
.choice-card {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px 8px;
  border: 1px solid var(--theme-40, #bdbdbd);
  border-radius: 12px;
  background: #fff;
  color: inherit;
}
.choice-card:hover,
.choice-card:focus-visible {
  border-color: var(--color, #333);
}
.choice-icon {
  font-size: 36px;
  color: var(--color, #333);
}
.choice-name {
  font-weight: 600;
}
.choice-text {
  font-size: 13px;
  opacity: 0.75;
  text-align: center;
}
.browse-link {
  border: 0;
  background: none;
  text-decoration: underline;
  color: inherit;
  font-size: 14px;
}
</style>
